import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import QuestionDisplay from '../marblemath/QuestionDisplay';
import GameData from '../data/GameData';
import MarbleDragCounter from '../marblemath/MarbleDragCounter';
import UIAssetKeys from '../UIAssetKeys';
import { addAnimationToSprite, MM_ANIMATIONS, PENGUIN_TALKING_ANIMATIONS } from '../AnimationManager';
import RoundIndicator from '../marblemath/RoundIndicator';
import HelpOverlay from '../marblemath/HelpOverlay';
import staticGameData from '../data/GameData';
import ResultsScreen from './ResultsScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  constructor() {
    super({ key: GameScreen.KEY });
  }

  init() {
    this.bg = null;

    this.penguinContainer = null;
    this.penguin = null;
    this.penguinShadow = null;

    this.questionDisplay = null; // Question and choices
    this.marbleCounter = null; // Marble drag and boxes

    this.btnHelp = null;
    this.helpOverlay = null;
    this.roundIndicator = null;

    /** @type {Phaser.Sound.HTML5AudioSound | Phaser.Sound.WebAudioSound} */
    this.currentSound = null;

    // stop all sounds (including the music)
    this.sound.stopAll();
  }

  create() {
    this.bg = this.add.image(0,0,'gamebackground').setOrigin(0);

    // Multiple choice question
    this.questionDisplay = new QuestionDisplay(this);
    this.questionDisplay.scaleX = 0.85;
    this.questionDisplay.scaleY = 0.85;
    this.questionDisplay.x = this.scale.width / 2 - this.questionDisplay.bg.width / 2 + 60;
    this.questionDisplay.y = 100;
    this.questionDisplay.on('INIT_QUESTION', this.questionInitialized, this);
    this.questionDisplay.on('SUBMIT_ROUND', this.roundFinished, this);
    this.questionDisplay.on('SUBMIT_QUESTION', this.questionSubmitted, this);
    this.questionDisplay.on('INCORRECT_ANSWER', this.disappointPenguin, this);

    // Marble menu, drop boxes, counter/hint
    this.marbleCounter = new MarbleDragCounter(this);
    this.marbleCounter.x = 210;
    this.marbleCounter.y = 320;

    // Penguin
    this.penguinContainer = this.add.container();
    this.penguinShadow = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._mm_assets_RoundSelectPenguinShadow, this.penguinContainer).setOrigin(0);
    this.penguin = this.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS);
    addAnimationToSprite(this.penguin, MM_ANIMATIONS, 'game idle', true, true);
    addAnimationToSprite(this.penguin, MM_ANIMATIONS, 'correct', false);
    addAnimationToSprite(this.penguin, MM_ANIMATIONS, 'incorrect', false);
    this.penguinShadow.x = this.penguin.x - this.penguin.width + 35;
    this.penguinShadow.scaleX = 0.9;
    this.penguinShadow.y = this.penguin.y + this.penguin.height - 46;
    this.penguinContainer.add(this.penguin);
    this.penguinContainer.x = 178;
    this.penguinContainer.y = 125;
    this.sys.updateList.add(this.penguin); // bug fix for sprites in containers, they need re-added to the scene's update list

    // Round info/progress display
    this.roundIndicator = new RoundIndicator(this);
    this.roundIndicator.x = this.scale.width / 2 - this.roundIndicator.bg.width / 2;
    this.roundIndicator.y = -10;
    this.add.existing(this.roundIndicator);

    // Help button
    this.btnHelp = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._mm_common_assets_BtnHelp, this).setOrigin(0)
      .setInteractive();
    this.btnHelp.x = this.scale.width - this.btnHelp.width - 90;
    this.btnHelp.y = 20;
    this.btnHelp.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.showHelp, this);

    // Help popup
    this.helpOverlay = new HelpOverlay(this);
    this.helpOverlay.alpha = 0.1;
    this.helpOverlay.setVisible(false);
    this.add.existing(this.helpOverlay);

    this.add.existing(this.marbleCounter);

    if (!staticGameData.showedHelped) {
      staticGameData.showedHelped = true;
      this.helpOverlay.setVisible(true);
      ABCyaPhaser.Tweens.addTween(this.helpOverlay, 1200, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
      this.helpOverlay.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.firstHelpClick, this);
      this.currentSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._InstSound, this.currentSound);
    }
    else {
      this.questionDisplay.initQuestion();
      this.add.existing(this.questionDisplay);
      this.add.existing(this.marbleCounter);
    }

    this.layoutRatio();
  }

  questionInitialized (questionNumber) {
    this.roundIndicator.nextQuestion(questionNumber);
  }

  /**
   * 
   * @param {{ answer: any, num1: number, num2: number, incorrects: number }[]} roundData 
   */
  roundFinished (roundData) {
    this.marbleCounter.reset();
    this.btnHelp.disableInteractive();

    ABCyaPhaser.Tweens.addTween([this.questionDisplay, this.marbleCounter, this.penguinContainer, this.roundIndicator,this.btnHelp], 600, { alpha: 0, delay: 30 }, Phaser.Math.Easing.Linear, () => this.forreal());
    GameData.roundResults[GameData.currentRound - 1] = roundData;
  }

  forreal() {
    this.scene.start(ResultsScreen.KEY);
  }

  questionSubmitted () {
    this.marbleCounter.reset();
    this.penguin.play('correct');
  }

  disappointPenguin () {
    this.penguin.play('incorrect');
  }

  showHelp () {
    this.children.bringToTop(this.helpOverlay);
    this.helpOverlay.setVisible(true);
    this.tweens.killTweensOf(this.helpOverlay);
    ABCyaPhaser.Tweens.addTween(this.helpOverlay, 600, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    this.helpOverlay.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.hideHelp, this);
    this.questionDisplay.stopSounds();
    this.currentSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._InstSound, this.currentSound);
  }

  firstHelpClick () {
    this.helpOverlay.removeAllListeners();
    this.tweens.killTweensOf(this.helpOverlay);
    ABCyaPhaser.Tweens.addTween(this.helpOverlay, 600, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    this.questionDisplay.initQuestion();
    this.add.existing(this.questionDisplay);
    this.currentSound.destroy();
    this.currentSound = null;
  }

  hideHelp () {
    this.currentSound.destroy();
    this.currentSound = null;
    this.helpOverlay.removeAllListeners();
    this.tweens.killTweensOf(this.helpOverlay);
    ABCyaPhaser.Tweens.addTween(this.helpOverlay, 600, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  layoutRatio () {
    const s = 1.4;
    this.penguinContainer.scaleX = s * -1;
    this.penguinContainer.scaleY = s;
    const xx = 210;
    this.penguinContainer.x = xx;

    this.marbleCounter.layoutRatio();
    const counterY = this.scale.height - this.marbleCounter.getBounds().height + 100;
    this.marbleCounter.y = counterY;
  }

  update(time, delta) {
    this.marbleCounter.tick(delta);
  }
}